import React from "react";
import { array, string, bool } from "prop-types";
import { Link } from "@quintype/components";

import MenuItem from "../../atoms/menu-item";

import translate from "../../translate";

import "./secondary-menu.m.css";

const SecondaryMenu = ({ items, pageType, publisherName, isHomeMenuRequired, currentHostUrl }) => {
  if (!(items && items.length)) {
    return null;
  }

  const firstMenuItems = items.slice(0, 8);
  const subMenuItems = items.slice(8, items.length);

  const SubMenuItemView = () => (
    <ul styleName="sub-menu">
      {subMenuItems.map((item, index) => (
        <li className={`top-navbar-${firstMenuItems.length + index + 1}`} key={index} styleName="sub-menu-item">
          <MenuItem item={item} currentHostUrl={currentHostUrl} />
        </li>
      ))}
    </ul>
  );

  return (
    <ul styleName="wrapper">
      {/* Show Home as default */}
      {isHomeMenuRequired ? (
        <li
          className="top-navbar-home"
          styleName={`menu-item hide-menu-item ${pageType === "home-page" ? "highlighted-menu-item" : ""}`}
        >
          <Link href="/">{translate(publisherName, "home")}</Link>
        </li>
      ) : null}

      {/* Show only 6 items from menus in mobile */}
      {firstMenuItems.map((item, index) => (
        <li
          className={`top-navbar-${index + 1}`}
          key={index}
          styleName={`menu-item ${index <= 5 ? "" : "hide-menu-item"}`}
        >
          <MenuItem item={item} currentHostUrl={currentHostUrl} />
        </li>
      ))}

      {/* Show remaining items in More */}
      {subMenuItems.length ? (
        <li styleName="menu-item hide-menu-item">
          <div styleName="more-menu">
            <div styleName="down-arrow-icon">{translate(publisherName, "more")}</div>

            <SubMenuItemView />
          </div>
        </li>
      ) : null}
    </ul>
  );
};

SecondaryMenu.defaultProps = {
  isHomeMenuRequired: true,
};

SecondaryMenu.propTypes = {
  items: array,
  pageType: string,
  publisherName: string,
  isHomeMenuRequired: bool,
  currentHostUrl: string,
};

export default SecondaryMenu;
